<template>
  <div>
    <div class="content-box">
      <!-- Movil: regreso al listado arriba para que siempre se vea (en escritorio queda abajo) -->
      <router-link class="btn btn-sm btn-info d-inline-flex align-items-center d-md-none mb-2 req-btn-regresar"
        :to="{ name: 'inventario-req_traslado' }">
        <i class="os-icon os-icon-chevrons-left sliding-icon"></i>
        <span class="ml-1">Ver todos los Requerimientos</span>
      </router-link>
      <GraficoModalComponent v-if="current.id" :id="current.id" :modulo="'inv'" :path="'req_traslado'" />
      <br>
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <h5 class="form-header">
                Requerimiento de Traslado #{{ current.numero }}
                &nbsp; | &nbsp;
                <div class="badge" :class="{
                  'badge-success': current.estado == 'A',
                  'badge-warning': current.estado == 'B',
                  'badge-danger': current.estado == '9',
                }">
                  <i class="os-icon os-icon-ui-09"></i>
                  <span v-if="current.estado_str">{{ current.estado_str }}</span>
                  <span v-if="!current.estado_str">En Proceso</span>
                </div>
                <div class="st-meta float-right req-acciones-encabezado">
                  <div class="element-actions">
                    <button id="color_on_hover" @click="refreshCurrent()" class="btn">
                      Actualizar Info. <i class="fas fa-sync"></i>
                    </button>
                    &nbsp;
                    <div class="btn-group">
                      <button :disabled="!current.id" aria-expanded="false" aria-haspopup="true"
                        class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" type="button">
                        <i class="fa fa-cogs"></i>
                        Acciones
                      </button>
                      <div class="dropdown-menu dropdown-menu-right">
                        <!-- <button
                            class="dropdown-item"
                            :class="{ disabled: !(current.estado == 'B') }"
                            @click="abrir"
                            type="button"
                            :disabled="!(current.estado == 'B')"
                            href="#"
                          >
                            <i class="fa fa-unlock"></i>
                            Abrir Operación
                          </button> -->
                        <button class="dropdown-item" type="button" @click="cerrar" :disabled="!(current.estado == 'A')"
                          href="#">
                          <i class="fas fa-check"></i>
                          Finalizar Operación
                        </button>
                        <button class="dropdown-item" @click="anular" type="button" :disabled="!(current.estado != '9')"
                          href="#">
                          <i class="fa fa-archive"></i>
                          Anular Operación
                        </button>
                        <button class="dropdown-item" :disabled="current.estado != 'B'"
                          @click="generar_transferencia_stock()" href="#" type="button">
                          <i class="fa fa-paper-plane"></i>
                          Generar transferencia de stock
                        </button>
                        <div class="dropdown-divider"></div>
                        <button :disabled="current.estado == 'A'" class="dropdown-item" @click="imprimir" type="button">
                          <i class="fa fa-print"></i>
                          Imprimir
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </h5>
              <!-- Limpia el float de las acciones: sin esto, en movil la fila de campos se encoge
                   junto al float y cada campo queda de unos pocos pixeles de ancho -->
              <div class="clearfix"></div>
              <small v-if="current.errors && current.errors.detail" class="form-text text-danger">{{
                current.errors.detail }}</small>
              <!-- Pestanas (solo movil y con requerimiento creado), igual que conteos y cotizaciones -->
              <ul class="nav nav-tabs d-md-none mb-3" v-if="current.id">
                <li class="nav-item">
                  <a class="nav-link" :class="{ active: tabMovil === 'productos' }" href="#"
                    @click.prevent="tabMovil = 'productos'">
                    Productos
                    <span class="badge badge-pill badge-secondary">{{ (current.reqtrasladod_set || []).length }}</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" :class="{ active: tabMovil === 'datos' }" href="#"
                    @click.prevent="tabMovil = 'datos'">
                    Datos del Requerimiento
                  </a>
                </li>
              </ul>
              <div class="row" :class="{ 'req-oculto-movil': current.id && tabMovil !== 'datos' }">
                <div class="col-sm-3">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger': current.errors && current.errors.tienda,
                    }">Tienda o Bodega Origen</label>
                    <select class="form-control" autofocus="autofocus" v-model="current.tienda_pedir"
                      :disabled="!!current.id">
                      <option v-for="(tienda, key) in tiendas" :value="tienda.codigo" :key="key">
                        {{ tienda.codigo }}
                        -
                        {{ tienda.nombre }}
                      </option>
                    </select>
                    <small v-if="current.errors && current.errors.tienda_pedir" class="form-text text-danger">{{
                      current.errors.tienda_pedir[0] }}</small>
                    <span style="color: #3aac24" class="form-text">¡Tienda de donde se sacará el producto a
                      pedir!</span>
                  </div>
                </div>
                <div class="col-sm-3">
                  <TiendaSelectComponent titulo="Tienda o Bodega Destino" :current="current" :disabled="!!current.id"
                    :tiendas_lista="current.id ? null : tiendasDestino" />
                  <span style="color: #3aac24" class="form-text">¡Tienda a donde llegará el producto!, "mi
                    tienda"</span>
                </div>
                <div class="col-sm-2">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger': current.errors && current.errors.tipo,
                    }">Tipo</label>
                    <select class="form-control" autofocus="autofocus" v-model="current.tipo" :disabled="!!current.id">
                      <option value="N">Normal</option>
                      <option value="G">Punta de Góndola</option>
                      <option value="M">Pedido Mayoreo</option>
                      <option value="I">Insumos</option>
                      <option value="P">Próximos a Vencer</option>
                      <option value="A" disabled>Auto</option>
                      <option v-if="puedeDistribucionComercial || current.tipo === 'D'"
                        value="D">Distribución Comercial</option>
                    </select>
                    <small v-if="current.errors && current.errors.tipo" class="form-text text-danger">{{
                      current.errors.tipo[0] }}</small>
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger': current.errors && current.errors.fecha,
                    }">Fecha</label>
                    <input v-model="fecha_str" class="form-control" placeholder="Fecha" :disabled="true" type="text" />
                    <small v-if="current.errors && current.errors.fecha" class="form-text text-danger">{{
                      current.errors.fecha[0] }}</small>
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group">
                    <label>Usuario</label>
                    <input :disabled="true" class="form-control" v-model="current.usuario" type="text" />
                  </div>
                </div>
              </div>
              <!-- Cotizacion que respalda el excedente sobre el maximo (solo requerimientos manuales).
                   Punta de gondola no la requiere: solo se muestra si ya tiene una asignada. -->
              <div class="row" v-if="current.id && current.tipo != 'A' && (current.tipo != 'G' || current.cotizacion)"
                :class="{ 'req-oculto-movil': tabMovil !== 'productos' }">
                <div class="col-12">
                  <div class="alert py-2 mb-0" :class="current.cotizacion ? 'alert-info' : 'alert-warning border border-warning'">
                    <div class="d-flex justify-content-between align-items-center">
                      <div v-if="current.cotizacion">
                        <i class="fas fa-file-invoice"></i>
                        <b>Cotización Agregada
                          <router-link
                            :to="{ name: 'inventario-cotizaciones-requerimiento-editar', params: { id: current.cotizacion.id } }"
                            target="_blank">#{{ current.cotizacion.numero }}</router-link>
                        </b>
                        <span v-if="current.cotizacion.estado == 'A'" class="badge badge-warning">
                          Abierta: debe cerrarse para respaldar el excedente
                        </span>
                        &nbsp;|&nbsp; ({{ current.cotizacion.cliente_nit }}) {{ current.cotizacion.cliente_nombre }}
                        &nbsp;|&nbsp; Vence: {{ formatoFecha(current.cotizacion.fecha_vence) }}
                        <span v-if="current.cotizacion.esta_vencida" class="badge badge-danger">Vencida</span>
                      </div>
                      <div v-else class="font-weight-bold">
                        <i class="fas fa-exclamation-triangle"></i>
                        Sin Cotización. Es necesaria la cotización cuando un producto excede el máximo establecido para la tienda.
                      </div>
                      <div v-if="current.estado == 'A'">
                        <button v-if="!current.cotizacion" type="button" class="btn btn-sm btn-primary"
                          @click="showModalCotizaciones">
                          <i class="fa fa-link"></i>
                          Asignar cotización
                        </button>
                        <button v-else type="button" class="btn btn-sm btn-outline-danger" @click="quitarCotizacion">
                          <i class="fa fa-unlink"></i>
                          Quitar cotización
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div :class="{ 'req-oculto-movil': current.id && tabMovil !== 'productos' }">
                <br />
                <button type="button" class="btn btn-sm btn-dark btn-block" @click="showModalAddDetail"
                  v-if="current.estado == 'A' && current.id">
                  <i class="fa fa-plus"></i>
                  Agregar Producto
                </button>
              </div>
              <br />
              <!-- Escritorio: tabla. En movil (< 768px) se usan las tarjetas de abajo -->
              <div class="table-responsive d-none d-md-block" v-if="current.id != null && current.reqtrasladod_set.length > 0">
                <div class="text-right">
                  <span class="status-pill smaller green"></span>&nbsp;Abierta
                  <span class="status-pill smaller yellow"></span>&nbsp;Cerrada
                  <span class="status-pill smaller red"></span>&nbsp;Anulada
                </div>
                <br>
                <table class="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>SKU</th>
                      <th>Producto</th>
                      <th class="text-center">Unidad Medida</th>
                      <th class="text-center">Cantidad</th>
                      <th class="text-center">Unidades</th>
                      <th class="text-center">Pendiente</th>
                      <th class="text-center">Pickeando</th>
                      <th class="text-center">Total Pickeado</th>
                      <th class="text-center">En Tarima</th>
                      <th class="text-center">Finalizado en CEDIS</th>
                      <th class="text-center" v-if="current.tipo != 'A'">Excede Máx.</th>
                      <th class="text-center nowrap">Estado</th>
                      <th class="text-center">Opciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="detalle in current.reqtrasladod_set" v-bind:key="detalle.id">
                      <td>
                        <!--ProductoWithPopoverComponent :producto="detalle.producto" /-->
                        <b>{{ detalle.producto.sku }}</b>
                      </td>
                      <td>
                        {{ detalle.producto.nombre }}
                      </td>
                      <td>
                        {{ detalle.unidad_medida.nombre }}
                      </td>
                      <td class="text-right bolder nowrap" style="font-weight: 500">
                        <span class="text-success">+ {{ detalle.cantidad_um }}</span>
                      </td>
                      <td class="text-right bolder nowrap" style="font-weight: 500">
                        <span class="text-success">+ {{ detalle.cantidad }}</span>
                      </td>
                      <td class="text-right bolder nowrap" style="font-weight: 500">
                        <span v-bind:class="{
                          'text-danger': detalle.cantidad_abierta > '1',
                        }">{{ detalle.cantidad_abierta }}</span>
                      </td>
                      <td class="text-right bolder nowrap" style="font-weight: 500">
                        <span style="color: #0032ff">{{ detalle.pickeando }}</span>
                      </td>
                      <td class="text-right bolder nowrap" style="font-weight: 500">
                        <span style="color: #0032ff">{{ detalle.pickeado }}</span>
                      </td>
                      <td class="text-right bolder nowrap" style="font-weight: 500">
                        <span style="color: #0032ff">{{
                          detalle.cantidad_en_rotacion
                        }}</span>
                      </td>
                      <td class="text-right bolder nowrap" style="font-weight: 500">
                        <span style="color: #0032ff">{{ detalle.enviada }}</span>
                      </td>
                      <td class="text-center" v-if="current.tipo != 'A'">
                        <span v-if="detalle.cantidad_excedente > 0" class="badge badge-warning"
                          title="Unidades sobre el máximo respaldadas por la cotización">
                          {{ detalle.cantidad_excedente }}
                        </span>
                      </td>
                      <td class="text-center">
                        <span class="status-pill smaller green" v-if="detalle.estado == 'A'"></span>
                        <span class="status-pill smaller yellow" v-if="detalle.estado == 'B'"></span>
                        <span class="status-pill smaller red" v-if="detalle.estado == '9'"></span>
                      </td>
                      <td class="text-center" style="width: 200px">
                        <button class="btn btn-sm btn-danger mr-1" type="button" v-if="current.estado == 'A'"
                          @click="deleteDetalle(detalle)">
                          <i class="fa fa-trash"></i>
                          Eliminar
                        </button>
                        <button class="btn btn-sm btn-danger mr-1" type="button" v-if="!(current.estado == 'A')"
                          :disabled="detalle.cantidad_abierta == 0" @click="DarDeBajaReq(detalle)">
                          <i class="fa fa-archive"></i> &nbsp; Dar de baja
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-------------------- END - Basic Table -------------------->
              </div>
              <!-- Movil: mismo detalle y mismas acciones que la tabla, en tarjetas -->
              <div class="d-md-none" v-if="current.id != null && current.reqtrasladod_set.length > 0"
                :class="{ 'req-oculto-movil': tabMovil !== 'productos' }">
                <div class="req-leyenda">
                  <span class="status-pill smaller green"></span>&nbsp;Abierta
                  <span class="status-pill smaller yellow ml-2"></span>&nbsp;Cerrada
                  <span class="status-pill smaller red ml-2"></span>&nbsp;Anulada
                </div>
                <div v-for="detalle in current.reqtrasladod_set" v-bind:key="'movil_' + detalle.id" class="req-tarjeta"
                  :class="{
                    'req-tarjeta-abierta': detalle.estado == 'A',
                    'req-tarjeta-cerrada': detalle.estado == 'B',
                    'req-tarjeta-anulada': detalle.estado == '9',
                  }">
                  <div class="req-tarjeta-encabezado">
                    <div class="req-tarjeta-producto">
                      <div>
                        <b>{{ detalle.producto.sku }}</b>
                        <span class="status-pill smaller green ml-1" v-if="detalle.estado == 'A'"></span>
                        <span class="status-pill smaller yellow ml-1" v-if="detalle.estado == 'B'"></span>
                        <span class="status-pill smaller red ml-1" v-if="detalle.estado == '9'"></span>
                      </div>
                      <div class="req-tarjeta-nombre">{{ detalle.producto.nombre }}</div>
                      <small class="text-muted">{{ detalle.unidad_medida.nombre }}</small>
                    </div>
                    <div class="req-tarjeta-cantidad">
                      <div class="text-success">+ {{ detalle.cantidad_um }}</div>
                      <small class="text-muted">+ {{ detalle.cantidad }} unid.</small>
                    </div>
                  </div>
                  <div class="req-tarjeta-datos">
                    <div class="req-dato">
                      <span>Pendiente</span>
                      <b v-bind:class="{ 'text-danger': detalle.cantidad_abierta > '1' }">{{ detalle.cantidad_abierta }}</b>
                    </div>
                    <div class="req-dato">
                      <span>Pickeando</span>
                      <b style="color: #0032ff">{{ detalle.pickeando }}</b>
                    </div>
                    <div class="req-dato">
                      <span>Pickeado</span>
                      <b style="color: #0032ff">{{ detalle.pickeado }}</b>
                    </div>
                    <div class="req-dato">
                      <span>En tarima</span>
                      <b style="color: #0032ff">{{ detalle.cantidad_en_rotacion }}</b>
                    </div>
                    <div class="req-dato">
                      <span>Finalizado CEDIS</span>
                      <b style="color: #0032ff">{{ detalle.enviada }}</b>
                    </div>
                    <div class="req-dato" v-if="current.tipo != 'A' && detalle.cantidad_excedente > 0">
                      <span>Excede máx.</span>
                      <b><span class="badge badge-warning"
                          title="Unidades sobre el máximo respaldadas por la cotización">{{
                            detalle.cantidad_excedente }}</span></b>
                    </div>
                  </div>
                  <div class="req-tarjeta-acciones">
                    <button class="btn btn-sm btn-outline-danger" type="button" v-if="current.estado == 'A'"
                      @click="deleteDetalle(detalle)">
                      <i class="fa fa-trash"></i>
                      Eliminar
                    </button>
                    <button class="btn btn-sm btn-outline-danger" type="button" v-if="!(current.estado == 'A')"
                      :disabled="detalle.cantidad_abierta == 0" @click="DarDeBajaReq(detalle)">
                      <i class="fa fa-archive"></i>
                      Dar de baja
                    </button>
                  </div>
                </div>
              </div>
              <div class="form-buttons-w d-flex justify-content-start align-items-center">
                <!-- En movil este boton se muestra arriba -->
                <router-link class="btn btn-sm btn-info mr-2 d-none d-md-flex align-items-center"
                  :to="{ name: 'inventario-req_traslado' }" v-if="current.id">
                  <i class="os-icon os-icon-chevrons-left sliding-icon"></i>
                  <span class="ml-1">Ver todos los Requerimientos</span>
                </router-link>
                <router-link class="btn btn-sm btn-danger mr-2 d-flex align-items-center"
                  :to="{ name: 'inventario-req_traslado' }" v-if="!current.id">
                  <i class="os-icon os-icon-close"></i>
                  <span class="ml-1">Cancelar</span>
                </router-link>
                <button class="btn btn-md btn-success d-flex align-items-center" :hidden="current.id" @click="guardar()"
                  v-if="!current.id">
                  Guardar
                  <i class="os-icon os-icon-checkmark ml-1"></i>
                </button>
              </div>
              <br>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div aria-hidden="true" class="modal fade" id="modalAddDetailReqTraslado" role="dialog" tabindex="-1">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Agregar Producto</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        currentDetalle.errors && currentDetalle.errors.length > 0,
                    }"></label>
                    <ProductoSelectComponentV2 @onChangeProducto="onChangeProducto" :current="currentDetalle"
                      :tienda="current.tienda_id"></ProductoSelectComponentV2>
                    <small v-if="currentDetalle.errors" class="form-text text-danger">{{
                      currentDetalle.errors.detail
                    }}</small>
                    <!-- Desglose del maximo cuando la linea lo excede -->
                    <div v-if="currentDetalle.errors && currentDetalle.errors.desglose" class="mt-2">
                      <table class="table table-sm table-bordered mb-1 tabla-desglose">
                        <tbody>
                          <tr class="fila-maximo">
                            <td><i class="fas fa-flag"></i> Máximo en Tienda</td>
                            <td class="text-right">{{ formatoCantidad(currentDetalle.errors.desglose.maximo) }}</td>
                          </tr>
                          <tr v-if="currentDetalle.errors.desglose.minimo !== undefined" class="fila-minimo">
                            <td>Mínimo en Tienda</td>
                            <td class="text-right">{{ formatoCantidad(currentDetalle.errors.desglose.minimo) }}</td>
                          </tr>
                          <tr :class="estadoExistenciaDesglose.clase">
                            <td>
                              Existencia en tienda
                              <span v-if="estadoExistenciaDesglose.etiqueta" class="badge ml-1"
                                :class="'badge-' + estadoExistenciaDesglose.clase">{{ estadoExistenciaDesglose.etiqueta }}</span>
                            </td>
                            <td class="text-right">{{ formatoCantidad(currentDetalle.errors.desglose.existencia) }}</td>
                          </tr>
                          <tr class="fila-componente">
                            <td>Requerimientos abiertos</td>
                            <td class="text-right">{{ formatoCantidad(currentDetalle.errors.desglose.requerimientos) }}</td>
                          </tr>
                          <tr class="fila-componente">
                            <td>En tránsito</td>
                            <td class="text-right">{{ formatoCantidad(currentDetalle.errors.desglose.transito) }}</td>
                          </tr>
                          <tr class="fila-componente">
                            <td>Órdenes de compra abiertas</td>
                            <td class="text-right">{{ formatoCantidad(currentDetalle.errors.desglose.ordenes_compra) }}</td>
                          </tr>
                          <tr class="fila-solicitado">
                            <td><i class="fas fa-plus-circle"></i> Cantidad solicitada</td>
                            <td class="text-right">{{ formatoCantidad(currentDetalle.errors.desglose.solicitado) }}</td>
                          </tr>
                          <tr class="fila-proyectado">
                            <td>
                              Total proyectado
                              <span class="badge badge-sobre-maximo ml-1">Sobre el máximo</span>
                            </td>
                            <td class="text-right">{{ formatoCantidad(currentDetalle.errors.desglose.proyectado) }}</td>
                          </tr>
                          <tr v-if="Number(currentDetalle.errors.desglose.sobrestock_previo) > 0" class="fila-previo">
                            <td>
                              Sobre el máximo antes de agregar este requerimiento
                            </td>
                            <td class="text-right">{{ formatoCantidad(currentDetalle.errors.desglose.sobrestock_previo) }}</td>
                          </tr>
                          <tr class="fila-excedente">
                            <td><i class="fas fa-exclamation-circle"></i> Excedente</td>
                            <td class="text-right">{{ formatoCantidad(currentDetalle.errors.desglose.excedente) }}</td>
                          </tr>
                        </tbody>
                      </table>
                      <!-- Proporcion del total proyectado: dentro del maximo, sobrestock previo y excedente de la linea -->
                      <div class="barra-desglose">
                        <div class="barra-maximo" :style="{ width: porcentajeMaximoDesglose + '%' }"></div>
                        <div class="barra-previo" :style="{ width: porcentajePrevioDesglose + '%' }"></div>
                        <div class="barra-excedente"
                          :style="{ width: (100 - porcentajeMaximoDesglose - porcentajePrevioDesglose) + '%' }"></div>
                      </div>
                      <div class="d-flex justify-content-between small mt-1 mb-2">
                        <span class="texto-maximo">Dentro del máximo: {{ formatoCantidad(currentDetalle.errors.desglose.maximo) }}</span>
                        <span v-if="porcentajePrevioDesglose > 0" class="texto-previo">
                          Sobre el máximo previo: {{ formatoCantidad(currentDetalle.errors.desglose.sobrestock_previo) }}
                        </span>
                        <span class="texto-excedente">Excedente: {{ formatoCantidad(currentDetalle.errors.desglose.excedente) }}</span>
                      </div>
                      <button v-if="currentDetalle.errors.codigo == 'REQUIERE_COTIZACION' && !current.cotizacion"
                        type="button" class="btn btn-sm btn-primary" @click="showModalCotizaciones">
                        <i class="fa fa-link"></i>
                        Asignar cotización de respaldo
                      </button>
                    </div>
                    <!-- Indicador de carga para validación -->
                    <div v-if="currentDetalle.validando_producto" class="alert alert-info mt-2">
                      <div class="d-flex align-items-center">
                        <div class="spinner-border spinner-border-sm mr-2" role="status">
                          <span class="sr-only">Cargando...</span>
                        </div>
                        <small>Verificando si el producto ya existe en otros requerimientos...</small>
                      </div>
                    </div>

                    <!-- Alerta informativa para producto existente -->
                    <div v-if="currentDetalle.mostrar_alerta_producto_existente && !currentDetalle.validando_producto" 
                         class="alert mt-2" 
                         :class="{
                           'alert-warning': !currentDetalle.producto_existente_info.error,
                           'alert-danger': currentDetalle.producto_existente_info.error
                         }">
                      <div class="d-flex align-items-start">
                        <i class="mr-2 mt-1" 
                           :class="{
                             'fas fa-exclamation-triangle': !currentDetalle.producto_existente_info.error,
                             'fas fa-exclamation-circle': currentDetalle.producto_existente_info.error
                           }"></i>
                        <div class="flex-grow-1">
                          <strong v-if="!currentDetalle.producto_existente_info.error">¡Atención!</strong>
                          <strong v-else>¡Error de Validación!</strong>
                          {{ currentDetalle.producto_existente_info.mensaje }}
                          
                          <div v-if="!currentDetalle.producto_existente_info.error" class="mt-2">
                            <small class="text-muted">
                              ¿Desea continuar agregando este producto o prefiere buscar otro?
                            </small>
                          </div>
                          
                          <!-- Sugerencia adicional -->
                          <div v-if="currentDetalle.producto_existente_info.sugerencia" class="mt-2">
                            <small class="font-italic text-primary">
                              <i class="fas fa-lightbulb mr-1"></i>
                              {{ currentDetalle.producto_existente_info.sugerencia }}
                            </small>
                          </div>
                          
                          <!-- Lista de requerimientos encontrados -->
                          <div v-if="currentDetalle.producto_existente_info.requerimientos && 
                                    currentDetalle.producto_existente_info.requerimientos.length > 0" 
                               class="mt-3">
                            <button type="button" 
                                    class="btn btn-sm btn-outline-info" 
                                    @click="currentDetalle.mostrar_detalle_requerimientos = !currentDetalle.mostrar_detalle_requerimientos">
                              <i class="fas" :class="{
                                'fa-chevron-down': !currentDetalle.mostrar_detalle_requerimientos,
                                'fa-chevron-up': currentDetalle.mostrar_detalle_requerimientos
                              }"></i>
                              {{ currentDetalle.mostrar_detalle_requerimientos ? 'Ocultar' : 'Ver' }} detalles 
                              ({{ currentDetalle.producto_existente_info.requerimientos.length }} requerimiento{{currentDetalle.producto_existente_info.requerimientos.length !== 1 ? 's' : ''}})
                            </button>
                            
                            <div v-show="currentDetalle.mostrar_detalle_requerimientos" class="mt-2">
                              <div class="table-responsive">
                                <table class="table table-sm table-striped mb-0">
                                  <thead class="thead-light">
                                    <tr>
                                      <th style="font-size: 0.75rem;">Número</th>
                                      <th style="font-size: 0.75rem;">Tipo</th>
                                      <th style="font-size: 0.75rem;">Usuario</th>
                                      <th style="font-size: 0.75rem;">Cantidad</th>
                                      <th style="font-size: 0.75rem;">Estado</th>
                                      <th style="font-size: 0.75rem;">Fecha</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="req in currentDetalle.producto_existente_info.requerimientos" :key="req.numero">
                                      <td style="font-size: 0.75rem;"><strong>#{{ req.numero }}</strong></td>
                                      <td style="font-size: 0.75rem;">{{ req.tipo_descripcion }}</td>
                                      <td style="font-size: 0.75rem;">{{ req.usuario }}</td>
                                      <td style="font-size: 0.75rem;" class="text-right">{{ req.cantidad_um }}</td>
                                      <td style="font-size: 0.75rem;">
                                        <span class="badge" :class="{
                                          'badge-success': req.estado === 'A',
                                          'badge-warning': req.estado === 'B',
                                          'badge-danger': req.estado === '9'
                                        }">{{ req.estado_descripcion }}</span>
                                      </td>
                                      <td style="font-size: 0.75rem;">{{ req.fecha_creacion_formato }}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12">
                  <ProductoUnidadMedidaSelectComponent :current="currentDetalle.producto" />
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label v-bind:class="{
                      'text-danger':
                        currentDetalle.errors.cantidad_um &&
                        currentDetalle.errors.cantidad_um.length > 0,
                    }">Cantidad</label>
                    <input v-model="currentDetalle.cantidad_um" class="form-control" placeholder="Cantidad" type="text"
                      style="text-align: center; font-size: 200%" v-bind:class="{
                        'is-invalid':
                          currentDetalle.errors.cantidad_um &&
                          currentDetalle.errors.cantidad_um.length > 0,
                      }" />
                    <small v-if="currentDetalle.errors && currentDetalle.errors.cantidad_um"
                      class="form-text text-danger">{{ currentDetalle.errors.cantidad_um }}</small>
                  </div>
                </div>
                <div class="col-12">
                  <div class="el-tablo text-center">
                    <div class="label">Por Solicitar Automáticamente / Sugerido</div>
                    <div class="value" v-if="currentDetalle.a_pedir != null">
                      <h4 class="text-info">
                        {{ currentDetalle.a_pedir.pedir_um }} de
                        {{ currentDetalle.a_pedir.unidad_medida }}
                      </h4>
                    </div>
                    <div class="value" v-if="
                      currentDetalle.producto != null &&
                      currentDetalle.producto.sku != null &&
                      currentDetalle.a_pedir == null
                    ">
                      <h4 class="text-warning">Sin sugerido</h4>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="agregaDetalle" type="submit">
              Agregar
            </button>
            <button class="btn btn-secondary" ref="cerrarModal" data-dismiss="modal" type="button">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div aria-hidden="true" class="modal fade" id="modalCotizacionesReqTraslado" role="dialog" tabindex="-1">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Cotizaciones disponibles</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p class="text-muted mb-2">
              Cotizaciones de requerimiento cerradas, vigentes, de la misma tienda destino y sin usar.
            </p>
            <div v-if="cotizaciones_disponibles.length == 0" class="alert alert-warning">
              No hay cotizaciones disponibles para esta tienda.
              <router-link
                :to="{ name: 'inventario-cotizaciones-requerimiento-nuevo', query: { req: current.id, tienda: current.tienda_id || current.tienda } }"
                target="_blank">
                Crear cotización
              </router-link>
            </div>
            <!-- Escritorio: tabla. En movil (< 768px) se usan las tarjetas de abajo para que el boton Asignar quede visible -->
            <table v-else class="table table-sm table-striped d-none d-md-table">
              <thead>
                <tr>
                  <th>Número</th>
                  <th>Cliente</th>
                  <th>Vence</th>
                  <th>Productos</th>
                  <th class="text-right">Total</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="cot in cotizaciones_disponibles" :key="cot.id">
                  <td><b>#{{ cot.numero }}</b></td>
                  <td>({{ cot.cliente_nit }}) {{ cot.cliente_nombre }}</td>
                  <td>{{ formatoFecha(cot.fecha_vence) }}</td>
                  <td>
                    <div v-for="linea in cot.lineas" :key="linea.producto">
                      <small>{{ linea.producto }} - {{ linea.producto_nombre }}: <b>{{ linea.cantidad }}</b></small>
                    </div>
                  </td>
                  <td class="text-right">Q {{ cot.total }}</td>
                  <td>
                    <button type="button" class="btn btn-sm btn-primary" @click="asignarCotizacion(cot)">
                      Asignar
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- Movil: una tarjeta por cotizacion (solo encabezado, sin productos) con el boton de asignar a todo el ancho.
                 El backend ya excluye las vencidas y las asignadas a otro requerimiento. -->
            <div v-if="cotizaciones_disponibles.length > 0" class="d-md-none">
              <div v-for="cot in cotizaciones_disponibles" :key="'movil_' + cot.id" class="req-cot-tarjeta">
                <div class="d-flex justify-content-between align-items-center">
                  <b>#{{ cot.numero }}</b>
                  <b class="text-success">Q {{ formatoMonto(cot.total) }}</b>
                </div>
                <div class="req-tarjeta-nombre">
                  <small class="text-muted">NIT:</small> {{ cot.cliente_nit }}
                </div>
                <div class="req-tarjeta-nombre">{{ cot.cliente_nombre }}</div>
                <small class="text-muted">Vence: {{ formatoFecha(cot.fecha_vence) }}</small>
                <button type="button" class="btn btn-success btn-block mt-2" @click="asignarCotizacion(cot)">
                  <i class="fa fa-link"></i>
                  Asignar cotización
                </button>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" data-dismiss="modal" type="button">Cerrar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Aviso verde (solo movil) para crear requerimiento, agregar producto y finalizar.
         En escritorio se mantiene el modal de exito. -->
    <transition name="req-aviso">
      <div v-if="aviso" class="req-aviso" @click="cerrarAviso">
        <i class="fas fa-check-circle"></i>
        <div class="req-aviso-texto">
          <b>{{ aviso.titulo }}</b>
          <div>{{ aviso.mensaje }}</div>
          <button v-if="aviso.accion" type="button" class="btn btn-sm btn-light mt-2"
            @click.stop="irAccionAviso">
            {{ aviso.accion.texto }}
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import CommonService from "@/services/commons/CommonService";
import ProductosService from "@/services/catalogos/ProductosService";
import ReqTrasladoService from "@/services/inventario/ReqTrasladoService";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ProductoUnidadMedidaSelectComponent from "@/components/commons/ProductoUnidadMedidaSelectComponent";
import ProductoWithPopoverComponent from "@/components/commons/ProductoWithPopoverComponent";
import DynamicService from "@/services/commons/DynamicService";
import SalidaTrasladoService from "@/services/inventario/SalidaTrasladoService";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import GraficoModalComponent from "@/components/commons/GraficoModalComponent";
import { mostrarResumenCargaCotizacion } from "@/components/inventario/cotizaciones_requerimiento/resumenCargaCotizacion";

const DURACION_AVISO_MS = 2500;
// Aviso con boton de accion (ej. ir al listado): se deja mas tiempo para poder tocarlo
const DURACION_AVISO_ACCION_MS = 7000;

export default {
  components: {
    TiendaSelectComponent,
    ProductoUnidadMedidaSelectComponent,
    ProductoWithPopoverComponent,
    ProductoSelectComponentV2,
    GraficoModalComponent,
  },
  data() {
    return {
      current: {
        id: null,
        estado_str: null,
        tienda: null,
        tienda_pedir: '02', // Set bodega 02 como valor default de tienda a Pedir
        fecha: "01/01/2019",
        estado: "A",
        tipo: "-",
        errors: {
          tienda: "",
          fecha: "",
        },
        reqtrasladod_set: [],
      },

      unidades_medidas: [],
      productos: [],
      options: [],
      cotizaciones_disponibles: [],
      tiendasDestino: [],
      // Pestana visible en movil: productos (detalle) o datos del requerimiento
      tabMovil: "productos",
      aviso: null,
      timerAviso: null,

      currentDetalle: {
        cantidad: 0,
        cantidad_um: "",
        producto: {
          sku: null,
          unidad_medida: null,
          errors: [],
        },
        a_pedir: null,
        errors: [],
        producto_existente_info: null,
        mostrar_alerta_producto_existente: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
    puedeDistribucionComercial() {
      let vistas = [];
      try {
        vistas = JSON.parse(localStorage.getItem("vistas_permitidas")) || [];
      } catch (e) {
        vistas = [];
      }
      return vistas.includes("DISTRIBUCION_COMERCIAL");
    },
    fecha_str: function () {
      let self = this;
      return self.customFormatter(self.current.fecha);
    },
    /**
     * Porcentaje del total proyectado que cabe dentro del maximo de la tienda.
     * Se usa en la barra del desglose (el resto es excedente).
     */
    porcentajeMaximoDesglose() {
      const desglose = this.currentDetalle.errors && this.currentDetalle.errors.desglose;
      if (!desglose) {
        return 100;
      }
      const proyectado = Number(desglose.proyectado) || 0;
      const maximo = Number(desglose.maximo) || 0;
      if (proyectado <= 0) {
        return 100;
      }
      return Math.min(100, Math.max(0, (maximo / proyectado) * 100));
    },
    /**
     * Porcentaje del total proyectado que ya estaba sobre el maximo antes de esta
     * solicitud (sobrestock previo; no lo cubre la cotizacion de esta linea).
     */
    porcentajePrevioDesglose() {
      const desglose = this.currentDetalle.errors && this.currentDetalle.errors.desglose;
      if (!desglose) {
        return 0;
      }
      const proyectado = Number(desglose.proyectado) || 0;
      const previo = Number(desglose.sobrestock_previo) || 0;
      if (proyectado <= 0 || previo <= 0) {
        return 0;
      }
      return Math.min(100 - this.porcentajeMaximoDesglose, Math.max(0, (previo / proyectado) * 100));
    },
    /**
     * Estado de la existencia en tienda respecto al minimo y maximo.
     * Si el minimo no esta configurado (0), solo se compara contra el maximo.
     */
    estadoExistenciaDesglose() {
      const desglose = this.currentDetalle.errors && this.currentDetalle.errors.desglose;
      if (!desglose) {
        return { clase: "fila-componente", etiqueta: "" };
      }
      const existencia = Number(desglose.existencia) || 0;
      const minimo = Number(desglose.minimo) || 0;
      const maximo = Number(desglose.maximo) || 0;
      if (maximo > 0 && existencia > maximo) {
        return { clase: "existencia-sobre-maximo", etiqueta: "Sobre el máximo" };
      }
      if (maximo > 0 && existencia === maximo) {
        return { clase: "existencia-en-maximo", etiqueta: "En el máximo" };
      }
      if (minimo > 0 && existencia < minimo) {
        return { clase: "existencia-bajo-minimo", etiqueta: "Bajo el mínimo" };
      }
      if (minimo > 0 && existencia === minimo) {
        return { clase: "existencia-en-minimo", etiqueta: "En el mínimo" };
      }
      return { clase: "existencia-en-rango", etiqueta: "En rango" };
    },
  },
  mounted() {
    let self = this;
    CommonService.fecha_actual().then((res) => {
      self.current.fecha = res.data.fecha_actual;
    });
    if (this.$route.params.id) {
      self.refreshCurrent();
    } else {
      self.cargarTiendasDestino();
    }
  },
  beforeDestroy() {
    if (this.timerAviso) {
      clearTimeout(this.timerAviso);
    }
  },
  methods: {
    /**
     * Mismo corte que d-md-none: menos de 768px se considera movil.
     */
    esMovil() {
      return !!window.matchMedia && window.matchMedia("(max-width: 767px)").matches;
    },
    /**
     * accion (opcional): { texto, ruta } muestra un boton dentro del aviso.
     */
    mostrarAviso(titulo, mensaje, accion) {
      if (this.timerAviso) {
        clearTimeout(this.timerAviso);
      }
      this.aviso = { titulo: titulo, mensaje: mensaje, accion: accion || null };
      this.timerAviso = setTimeout(() => {
        this.aviso = null;
        this.timerAviso = null;
      }, accion ? DURACION_AVISO_ACCION_MS : DURACION_AVISO_MS);
    },
    irAccionAviso() {
      const accion = this.aviso ? this.aviso.accion : null;
      this.cerrarAviso();
      if (accion && accion.ruta) {
        this.$router.push(accion.ruta);
      }
    },
    cerrarAviso() {
      if (this.timerAviso) {
        clearTimeout(this.timerAviso);
        this.timerAviso = null;
      }
      this.aviso = null;
    },
    /**
     * Tiendas destino para un requerimiento nuevo segun tienda_usuario.
     * - Solo se listan las tiendas asignadas al usuario (activas).
     * - Si tiene predeterminada, o una sola tienda, queda seleccionada.
     * - Si no tiene asignadas, el select usa el listado general.
     */
    cargarTiendasDestino() {
      DynamicService.fetch("cat", "tienda-usuario", {
        myprofile: true,
        quitar_paginacion: true,
      })
        .then((response) => {
          const asignadas = Array.isArray(response.data)
            ? response.data
            : response.data.results || [];
          this.tiendasDestino = asignadas
            .map((item) => item.tienda)
            .filter((tienda) => tienda && tienda.activa);
          const predeterminada = asignadas.find((item) => item.predeterminada);
          const unica = this.tiendasDestino.length === 1 ? { tienda: this.tiendasDestino[0] } : null;
          const tiendaInicial = predeterminada || unica;
          if (!this.current.id && tiendaInicial && tiendaInicial.tienda) {
            this.current.tienda = tiendaInicial.tienda.codigo;
          }
        })
        .catch(() => {
          this.tiendasDestino = [];
        });
    },
    refreshCurrent() {
      let self = this;
      ReqTrasladoService.getById(this.$route.params.id).then((response) => {
        self.current = response.data;
        // Si el usuario no tiene nombre/apellido, name llega en blanco: se usa el username
        const usuarioReq = response.data.usuario || {};
        self.current.usuario = (usuarioReq.name || "").trim() || usuarioReq.username || "";
        self.current.tienda_id = response.data.tienda.codigo;
        self.current.tienda = response.data.tienda.codigo;
        self.current.tienda_pedir = response.data.tienda_pedir.codigo;
        self.current.tipo = response.data.tipo;
        self.current.fecha = self.customFormatter(self.current.fecha);
        self.current.errors = [];
        self.currentDetalle.errors = [];
        self.currentDetalle.cantidad = 0;
      });
    },
    refreshUnidadMedida(producto) {
      let self = this;
      ProductosService.getById(producto.sku).then((response) => {
        self.currentDetalle.producto = response.data;
        self.currentDetalle.producto.unidad_medida =
          self.currentDetalle.producto.productounidadmedida_set[0];
        self.currentDetalle.producto.unidades_medidas =
          self.currentDetalle.producto.productounidadmedida_set;
        self.currentDetalle.producto.unidad_medida =
          self.currentDetalle.producto.unidad_medida.unidad_medida.id;
      });
    },
    guardar() {
      let self = this;
      let current = Object.assign({}, self.current);
      current.tienda = self.current.tienda;
      ReqTrasladoService.save(current)
        .then((response) => {
          if (self.esMovil()) {
            const numero = response.data && response.data.numero ? ` #${response.data.numero}` : "";
            self.mostrarAviso("Requerimiento de traslado", `Requerimiento${numero} creado con éxito.`);
          } else {
            Notifications.alert.success("Guardar Cambios", "Realizado Exitosamente");
          }
          if (current.id == null) {
            self.$router.push({
              name: "inventario-req_traslado-editar",
              params: { id: response.data.id },
            });
            self.refreshCurrent();
          }
        })
        .catch((error) => {
          self.current.errors = error.response.data;
          Notifications.alert.error("Error", error.response.data.detail);
        });
    },
    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },

    onSearchProducto(search, loading) {
      loading(true);
      this.searchProducto(loading, search, this);
    },

    searchProducto: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      ProductosService.fetch({
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.productos = res.data;
        loading(false);
      });
    }, 350),
    customFormatter(date) {
      var d = date.toString().split("/");
      var str_d = d[2] + "-" + d[1] + "-" + d[0];

      return moment(str_d).format("DD/MM/YYYY");
    },
    showModalAddDetail() {
      let self = this;
      // Limpiar la información de producto existente al abrir el modal
      self.refreshDetalleDefault();
      
      ProductosService.fetch({
        page: 1,
        activo: true,
        permitir_compra: true,
      }).then((res) => {
        self.productos = res.data.results;
        $("#modalAddDetailReqTraslado").modal();
      });
    },

    agregaDetalle() {
      let self = this;
      let det = Object.assign({}, self.currentDetalle);
      if (det.producto) {
        det.producto = det.producto.sku;
        det.unidad_medida = self.currentDetalle.producto.unidad_medida;
        // Se arma antes de la peticion porque al terminar se limpia currentDetalle
        const nombreProducto = self.currentDetalle.producto.nombre || "";
        const textoAgregado = `${det.producto} ${nombreProducto} - ${det.cantidad_um}`;
        ReqTrasladoService.addDetail(self.current.id, det)
          .then((response) => {
            if (self.esMovil()) {
              self.mostrarAviso("Producto agregado", textoAgregado);
            } else {
              Notifications.alert.success(
                "Requerimiento de Traslado",
                "Se ha guardado la Información."
              );
            }
            self.refreshCurrent();
            self.refreshDetalleDefault();
            self.$refs.cerrarModal.click();
          })
          .catch((error) => {
            self.currentDetalle.errors = error.response.data;
          });
      }
    },
    deleteDetalle(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Requerimiento de Traslado",
        "¿Esta seguro de eliminar el registro?",
        "Si Eliminar",
        function () {
          ReqTrasladoService.deleteDetail(detalle.req_traslado_e, {
            id: detalle.id.replace("-", ""),
          })
            .then((response) => {
              Notifications.alert.success(
                "Requerimiento de Traslado",
                "Se ha eliminado la Información."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              self.current.errors = error.response.data;

              if (error.response.data.detail) {
                Notifications.alert.error(
                  "Requerimiento de Traslado",
                  error.response.data.detail
                );
              } else {
                if (error.response.data.salida_traslado_d) {
                  Notifications.alert.error(
                    "Requerimiento de Traslado",
                    error.response.data.salida_traslado_d
                  );
                }
              }
            });
        }
      );
    },
    DarDeBajaReq(detalle) {
      let self = this;
      Notifications.alert.confirm(
        "Dar de Baja a Requerimiento",
        "¿Esta seguro de dar de baja la linea?",
        "Si",
        function () {
          DynamicService.postAction(
            "inv",
            "req_traslado",
            detalle.req_traslado_e,
            "dar_de_baja_solicitud",
            {
              linea: detalle.id.replace(/-/g, ""),
            }
          )
            .then((response) => {
              Notifications.alert.success(
                "Dar de Baja a Requerimiento",
                "Se ha eliminado la Información."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              self.current.errors = error.response.data;

              if (error.response.data.detail) {
                Notifications.alert.error(
                  "Dar de Baja a Requerimiento",
                  error.response.data.detail
                );
              }
            });
        }
      );
    },
    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Requerimiento de Traslado",
        "Desea Abrir la transacción?",
        "Si Abrir",
        function () {
          ReqTrasladoService.abrir(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Requerimiento de Traslado",
                "Transaccion abierta puede continuar editando."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              if (error.response.data.detail) {
                Notifications.alert.error(
                  "Anular Transaccion",
                  error.response.data.detail
                );
              } else {
                Notifications.alert.error(
                  "Anular Transaccion",
                  error.response.data.salida_traslado_d
                );
              }
            });
        }
      );
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "¿Desea Finalizar el Requerimiento?",
        "Si realiza esta transacción, no podrá abrirse de nuevo",
        "Si, Finalizar",
        function () {
          ReqTrasladoService.cerrar(self.current.id)
            .then((response) => {
              if (self.esMovil()) {
                self.mostrarAviso(
                  "Finalizar requerimiento",
                  `Requerimiento #${self.current.numero} finalizado con éxito.`,
                  { texto: "Ir a requerimientos de traslado", ruta: { name: "inventario-req_traslado" } }
                );
              } else {
                Notifications.alert.success(
                  "¡Hecho!",
                  "Se Finalizó la transacción."
                );
              }
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("No se pudo Finalizar el Requerimiento", error.response.data.detail);
            });
        }
      );
    },
    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Requerimiento de Traslado",
        "Desea anular la Transacción?",
        "Si, Anular",
        function () {
          ReqTrasladoService.anular(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Requerimiento de Traslado",
                "Se ha anulado la transacción."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              if (error.response.data.detail) {
                Notifications.alert.error(
                  "Anular Transaccion",
                  error.response.data.detail
                );
              } else {
                Notifications.alert.error(
                  "Anular Transaccion",
                  error.response.data.salida_traslado_d
                );
              }
            });
        }
      );
    },
    generar_transferencia_stock() {
      let self = this;
      Notifications.alert.confirm(
        "Generar Transferencia de Stock",
        "¿Esta seguro(a)",
        "Si, Generar",
        function () {
          DynamicService.postAction(
            "inv",
            "req_traslado",
            self.current.id,
            "generar_transferencia_stock"
          )
            .then((res) => {
              Notifications.alert.success(
                "Generar Transferencia de Stock",
                "Realizado Exitosamente"
              );
            })
            .catch((error) => {
              if (error.response.data.detail) {
                Notifications.alert.error(
                  "Generar transferencia de stock",
                  error.response.data.detail
                );
              }
            });
        }
      );
    },
    generar_salida() {
      let self = this;
      Notifications.alert.confirm(
        "Generar Salida de Producto a partir de un Requerimiento de Traslado",
        "¿Desea Generar una salida de bodega a partir de este requerimiento de traslado?",
        "Si, Generar",
        function () {
          ReqTrasladoService.generar_salida(self.current.id)
            .then((res) => {
              SalidaTrasladoService.getById(res.data.salida_traslado_e).then(
                (response) => {
                  self.current.salida = response.data;
                  Notifications.alert.success(
                    "Requerimiento de Traslado",
                    `salida Generada # ${self.current.salida.numero}`
                  );
                }
              );
              self.$router.push({
                name: "inventario-salida_traslado-editar",
                params: { id: res.data.salida_traslado_e },
              });
            })
            .catch((error) => {
              if (error.response.data.detail) {
                Notifications.alert.error(
                  "Anular Transaccion",
                  error.response.data.detail
                );
              } else {
                Notifications.alert.error(
                  "Anular Transaccion",
                  error.response.data.salida_traslado_d
                );
              }
            });
        }
      );
    },
    onChangeProducto(producto) {
      let self = this;
      self.refreshUnidadMedida(producto);
      self.refreshSugerido(producto);
      self.validarProductoExistente(producto);
    },
    refreshUnidadMedida(producto) {
      let self = this;
      ProductosService.getById(producto.sku).then((response) => {
        self.currentDetalle.producto = response.data;
        self.currentDetalle.producto.unidad_medida =
          self.currentDetalle.producto.productounidadmedida_set[0];
        self.currentDetalle.producto.unidades_medidas =
          self.currentDetalle.producto.productounidadmedida_set;
        self.currentDetalle.producto.unidad_medida =
          self.currentDetalle.producto.unidad_medida.unidad_medida.id;
      });
    },
    refreshSugerido(producto) {
      let self = this;
      self.currentDetalle.a_pedir = null;
      console.log(self.current);
      DynamicService.getActionList("inv", "req_traslado", "vw_a_pedir", {
        tienda: self.current.tienda_id,
        sku: producto.sku,
      }).then((response) => {
        if (response.data.length > 0) {
          console.log(response.data[0]);
          self.currentDetalle.a_pedir = response.data[0];
        }
      });
    },
    refreshDetalleDefault() {
      let self = this;
      self.currentDetalle = {
        cantidad: "",
        cantidad_um: "",
        unidad_medida: null,
        proveedor: null,
        producto: {
          sku: null,
          unidad_medida: null,
          errors: [],
        },
        a_pedir: null,
        errors: [],
      };
    },

    validarProductoExistente(producto) {
      let self = this;
      if (!producto || !producto.sku || !self.current.tienda_id) {
        self.currentDetalle.producto_existente_info = null;
        self.currentDetalle.mostrar_alerta_producto_existente = false;
        return;
      }

      ReqTrasladoService.validarProductoExistente({
        producto_sku: producto.sku,
        tienda_id: self.current.tienda_id
      }).then((response) => {
        self.currentDetalle.producto_existente_info = response.data;
        self.currentDetalle.mostrar_alerta_producto_existente = response.data.existe_en_requerimientos;
      }).catch((error) => {
        console.error('Error validando producto existente:', error);
        self.currentDetalle.producto_existente_info = null;
        self.currentDetalle.mostrar_alerta_producto_existente = false;
      });
    },

    formatoCantidad(valor) {
      // 45.0 -> 45, 12.5 -> 12.5 (maximo 2 decimales)
      const numero = Number(valor);
      if (valor === null || valor === undefined || isNaN(numero)) {
        return valor;
      }
      return numero.toLocaleString("es-GT", { maximumFractionDigits: 2 });
    },
    formatoMonto(valor) {
      // 43.5 -> 43.50
      const numero = Number(valor || 0);
      return numero.toLocaleString("es-GT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    formatoFecha(fecha) {
      // yyyy-mm-dd -> dd/mm/yyyy
      if (!fecha) {
        return "";
      }
      const partes = String(fecha).split("-");
      if (partes.length == 3) {
        return `${partes[2]}/${partes[1]}/${partes[0]}`;
      }
      return fecha;
    },
    showModalCotizaciones() {
      let self = this;
      $("#modalAddDetailReqTraslado").modal("hide");
      DynamicService.getAction("inv", "req_traslado", self.current.id, "cotizaciones_disponibles")
        .then((response) => {
          self.cotizaciones_disponibles = response.data;
          $("#modalCotizacionesReqTraslado").modal();
        })
        .catch((error) => {
          Notifications.alert.error("Cotizaciones", error.response.data.detail);
        });
    },
    asignarCotizacion(cotizacion) {
      let self = this;
      Notifications.alert.confirm(
        "Asignar Cotización",
        `¿Asignar la cotización #${cotizacion.numero} a este requerimiento? Sus productos se agregarán al requerimiento en la unidad de medida de la cotización (si ya existe el producto con esa unidad de medida, se reemplaza su cantidad). Una vez asignada, la cotización queda bloqueada y no podrá usarse en otro requerimiento.`,
        "Sí, asignar",
        function () {
          DynamicService.postAction("inv", "req_traslado", self.current.id, "asignar_cotizacion", {
            cotizacion_e: cotizacion.id,
          })
            .then((response) => {
              $("#modalCotizacionesReqTraslado").modal("hide");
              const carga = response && response.data ? response.data.carga_requerimiento : null;
              if (!mostrarResumenCargaCotizacion(carga)) {
                Notifications.toast.success("Cotización", `Cotización #${cotizacion.numero} asignada`);
              }
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Asignar Cotización", error.response.data.detail);
            });
        }
      );
    },
    quitarCotizacion() {
      let self = this;
      Notifications.alert.confirm(
        "Quitar Cotización",
        "¿Desea quitar la cotización de este requerimiento?",
        "Sí, quitar",
        function () {
          DynamicService.postAction("inv", "req_traslado", self.current.id, "quitar_cotizacion")
            .then(() => {
              Notifications.toast.success("Cotización", "Cotización retirada del requerimiento");
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Quitar Cotización", error.response.data.detail);
            });
        }
      );
    },
    imprimir() {
      let op = this.$route.params.id.replace(/-/g, "");
      let us = localStorage.getItem("id_usuario");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=inventario/Req_traslados/ReqTraslado.jrxml&usuario=${us}&id=${op}`
      );
    },
    productoClickSku(producto, e) {
      let content = "producto.nombre";
      $(event.target).popover({
        title: producto.sku,
        content: content,
        trigger: "focus",
        placement: "top",
      });
      $(event.target).popover("show");
    },
  },
};
</script>

<style scoped>
/* En movil las acciones del encabezado van en su propia linea, debajo del titulo */
@media (max-width: 767px) {
  .req-acciones-encabezado {
    float: none !important;
    display: block;
    margin-top: 10px;
  }

  .req-acciones-encabezado .element-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

@media (max-width: 767.98px) {
  .req-oculto-movil {
    display: none !important;
  }
}

.req-btn-regresar {
  min-height: 36px;
}

/* Detalle en tarjetas (movil) */
.req-leyenda {
  font-size: 0.8rem;
  text-align: right;
  margin-bottom: 8px;
}

.req-tarjeta {
  border: 1px solid #e9ecef;
  border-left-width: 4px;
  border-radius: 6px;
  padding: 10px 12px;
  margin-bottom: 10px;
  background-color: #fff;
}

.req-tarjeta-abierta {
  border-left-color: #24b314;
}

.req-tarjeta-cerrada {
  border-left-color: #f8bc34;
}

.req-tarjeta-anulada {
  border-left-color: #e65252;
  background-color: #fdf5f5;
}

.req-tarjeta-encabezado {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.req-tarjeta-producto {
  flex: 1;
  min-width: 0;
}

.req-tarjeta-nombre {
  font-size: 0.9rem;
  overflow-wrap: anywhere;
}

.req-tarjeta-cantidad {
  text-align: right;
  margin-left: 10px;
  white-space: nowrap;
  font-weight: bold;
  font-size: 1.1rem;
  line-height: 1.2;
}

.req-tarjeta-cantidad small {
  display: block;
  font-weight: normal;
  font-size: 0.75rem;
}

/* Margenes en lugar de gap: algunas handheld usan WebView antiguos */
.req-tarjeta-datos {
  display: flex;
  flex-wrap: wrap;
  margin: 8px -4px 0;
  padding-top: 8px;
  border-top: 1px dashed #e9ecef;
}

.req-dato {
  width: 33.333%;
  padding: 0 4px;
  margin-bottom: 6px;
}

/* Solo la etiqueta (no el badge de "Excede max.") */
.req-dato > span {
  display: block;
  font-size: 0.7rem;
  color: #6c757d;
  line-height: 1.1;
}

.req-dato b {
  font-size: 0.95rem;
}

.req-tarjeta-acciones {
  text-align: right;
}

.req-tarjeta-acciones .btn {
  min-height: 36px;
}

/* Cotizaciones disponibles en tarjetas (movil) */
.req-cot-tarjeta {
  border: 1px solid #e9ecef;
  border-left: 4px solid #24b314;
  border-radius: 6px;
  padding: 10px 12px;
  margin-bottom: 10px;
  background-color: #fff;
}

.req-cot-tarjeta .btn {
  min-height: 44px;
}

/* Aviso de resultado (movil), igual al de la cotizacion movil */
.req-aviso {
  position: fixed;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1100;
  width: calc(100% - 24px);
  max-width: 520px;
  display: flex;
  align-items: center;
  padding: 14px 16px;
  border-radius: 8px;
  color: #fff;
  background-color: #28a745;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

.req-aviso i {
  font-size: 2rem;
  margin-right: 12px;
}

.req-aviso-texto {
  flex: 1;
  min-width: 0;
}

.req-aviso-enter-active,
.req-aviso-leave-active {
  transition: opacity 0.2s ease;
}

.req-aviso-enter,
.req-aviso-leave-to {
  opacity: 0;
}

/* Desglose del maximo en el modal Agregar Producto */
.tabla-desglose td {
  vertical-align: middle;
}
.tabla-desglose td:first-child {
  border-left-width: 4px;
  border-left-style: solid;
}
.tabla-desglose .fila-maximo td {
  background-color: #eff6ff;
  color: #1e40af;
  font-weight: 700;
}
.tabla-desglose .fila-maximo td:first-child {
  border-left-color: #3b82f6;
}
.tabla-desglose .fila-componente td {
  color: #4b5563;
}
.tabla-desglose .fila-componente td:first-child {
  border-left-color: #d1d5db;
}
.tabla-desglose .fila-solicitado td {
  background-color: #fffbeb;
  color: #92400e;
  font-weight: 600;
}
.tabla-desglose .fila-solicitado td:first-child {
  border-left-color: #f59e0b;
}
.tabla-desglose .fila-proyectado td {
  background-color: #fff7ed;
  color: #9a3412;
  font-weight: 700;
}
.tabla-desglose .fila-proyectado td:first-child {
  border-left-color: #f97316;
}
.tabla-desglose .fila-excedente td {
  background-color: #fef2f2;
  color: #b91c1c;
  font-weight: 700;
}
.tabla-desglose .fila-excedente td:first-child {
  border-left-color: #ef4444;
}
.badge-sobre-maximo {
  background-color: #f97316;
  color: #ffffff;
  font-weight: 600;
}
.barra-desglose {
  display: flex;
  width: 100%;
  height: 10px;
  border-radius: 5px;
  overflow: hidden;
  background-color: #e5e7eb;
}
.barra-maximo {
  background-color: #3b82f6;
}
.barra-excedente {
  background-color: #ef4444;
}
.barra-previo {
  background-color: #fdba74;
}
.texto-previo {
  color: #9a3412;
  font-weight: 600;
}
.tabla-desglose .fila-previo td {
  background-color: #fff7ed;
  color: #9a3412;
}
.tabla-desglose .fila-previo td:first-child {
  border-left-color: #fdba74;
}
.texto-maximo {
  color: #1e40af;
  font-weight: 600;
}
.texto-excedente {
  color: #b91c1c;
  font-weight: 600;
}
/* Minimo establecido y estado de la existencia respecto a minimo/maximo */
.tabla-desglose .fila-minimo td {
  background-color: #f8fafc;
  color: #1e40af;
  font-weight: 600;
}
.tabla-desglose .fila-minimo td:first-child {
  border-left-color: #93c5fd;
}
.tabla-desglose .existencia-bajo-minimo td {
  background-color: #fef2f2;
  color: #b91c1c;
  font-weight: 600;
}
.tabla-desglose .existencia-bajo-minimo td:first-child {
  border-left-color: #ef4444;
}
.tabla-desglose .existencia-en-minimo td {
  background-color: #fffbeb;
  color: #92400e;
  font-weight: 600;
}
.tabla-desglose .existencia-en-minimo td:first-child {
  border-left-color: #f59e0b;
}
.tabla-desglose .existencia-en-rango td {
  background-color: #f0fdf4;
  color: #166534;
  font-weight: 600;
}
.tabla-desglose .existencia-en-rango td:first-child {
  border-left-color: #22c55e;
}
.tabla-desglose .existencia-en-maximo td {
  background-color: #eff6ff;
  color: #1e40af;
  font-weight: 600;
}
.tabla-desglose .existencia-en-maximo td:first-child {
  border-left-color: #3b82f6;
}
.tabla-desglose .existencia-sobre-maximo td {
  background-color: #fff7ed;
  color: #9a3412;
  font-weight: 600;
}
.tabla-desglose .existencia-sobre-maximo td:first-child {
  border-left-color: #f97316;
}
.badge-existencia-bajo-minimo {
  background-color: #ef4444;
  color: #ffffff;
}
.badge-existencia-en-minimo {
  background-color: #f59e0b;
  color: #ffffff;
}
.badge-existencia-en-rango {
  background-color: #22c55e;
  color: #ffffff;
}
.badge-existencia-en-maximo {
  background-color: #3b82f6;
  color: #ffffff;
}
.badge-existencia-sobre-maximo {
  background-color: #f97316;
  color: #ffffff;
}
</style>